export default __webpack_public_path__ + "static/media/SQL.1819c668.jpg";